import { useState } from "react";
import { Provider } from "react-redux";
import NavBar from "./components/NavBar";
import CartPage from "./pages/CartPage";
import HomePage from "./pages/HomePage";
import { store } from "./redux/store";

export default function App() {
  const [toggle, setToggle] = useState();

  return (
    <Provider store={store}>
      <div>

        <NavBar setToggle={setToggle} />

        <main className="py-16">
          {!toggle ? <HomePage /> : <CartPage />}
        </main>

      </div>
    </Provider>
  );
}

